import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import PaymentInOutHeader from "../../sales-section/payment-in-out-header";
import PaymentInOutTable from "../../sales-section/payment-in-out-table";

import {
  paymentOutCreateAction,
  paymentOutEditAction,
} from "../../../redux/actions/purchase-action";
import { paymentMethodListAction } from "../../../redux/actions/general-action";
import PurchasePaymentPanel from "./purchase-payment-panel";
import LoadingSpinner from "../../helper-components/loading-spinner";
import LoadingOverlay from "../../helper-components/overlay-loading";
import PaymentInOutFooter from "../../sales-section/payment-in-out-footer";
const CreateEditViewPurchasePaymentOut = ({ data = {}, page, disabled }) => {
  const [loading, setLoading] = useState(false);
  const [paymentPanel, setPaymentPanel] = useState(false);
  const [payModesList, setPayModesList] = useState([]);
  const [heading, setHeading] = useState([]);

  const [clearDue, setClearDue] = useState(false);

  const searchRef = useRef(null);
  const navigate = useNavigate();
  const [checkedId, setCheckedId] = useState(
    data?.invoiceData?.map((item) => item?.poit_id) ?? []
  );
  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  const today = new Date();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(paymentMethodListAction(onSuccessPayList, onErrorPayList));
    const data = localStorage.getItem("ModPermission");

    if (data) {
      const parsed = JSON.parse(data);
      console.table(parsed[38]["payment_out_create"]);

      const PayOutData = parsed.find((obj) => obj?.payment_out_create);
      if (PayOutData?.payment_out_create) {
        setHeading(PayOutData.payment_out_create);
      }
    }

    const updateHeight = () => {
      const firstDivHeight = document.querySelector(".first-div").clientHeight;
      setHeightOfFirstDiv(firstDivHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);
  const onErrorPayList = () => {};
  const onSuccessPayList = (data) => {
    setPayModesList(
      data?.data?.paymentModes.map((item) => {
        return { label: item?.paymentType, value: item?.paymentType };
      })
    );
  };

  const bankData = data?.paymentData?.find(
    (payment) => payment.pmt_mode_name === "Bank Transfer"
  );
  const cashData = data?.paymentData?.find(
    (payment) => payment.pmt_mode_name === "Cash"
  );
  const upiData = data?.paymentData?.find(
    (payment) => payment.pmt_mode_name === "UPI"
  );
  const cardData = data?.paymentData?.find(
    (payment) => payment.pmt_mode_name === "Card"
  );
  const chequeData = data?.paymentData?.find(
    (payment) => payment.pmt_mode_name === "Cheque"
  );

  const initialFormValues = {
    pot_id: data?.orderData?.pot_id ?? "",
    is_customer: false,
    cmr_id: data?.orderData?.cmr_id ?? "",
    cmr_code: data?.orderData?.cmr_id
      ? {
          label: data?.orderData?.cmr_code ?? "",
          value: data?.orderData?.cmr_id ?? "",
        }
      : "",
    cmr_name: data?.orderData?.cmr_id
      ? {
          label: data?.orderData?.cmr_name,
          value: data?.orderData?.cmr_id,
        }
      : "",
    pot_posting_date: data?.orderData?.pot_posting_date
      ? moment(data?.orderData?.pot_posting_date).format("YYYY-MM-DD")
      : moment(today).format("YYYY-MM-DD"),
    pot_due_date: data?.orderData?.pot_due_date
      ? moment(data?.orderData?.pot_due_date).format("YYYY-MM-DD")
      : moment(today).format("YYYY-MM-DD"),
    pot_doc_date: data?.orderData?.pot_doc_date
      ? moment(data?.orderData?.pot_doc_date).format("YYYY-MM-DD")
      : moment(today).format("YYYY-MM-DD"),
    payment_journal_remarks: data?.orderData?.payment_journal_remarks ?? "",
    remarks: data?.orderData?.remarks ?? "",
    is_payment_on_account: false,
    pot_cmr_amount_paid: 0, // added newly
    pot_current_payment: data?.orderData?.pot_current_payment ?? 0,
    pot_total_amount: data?.orderData?.pot_total_amount ?? (0).toFixed(2),
  
    ...(page === "view"
      ? { pot_add_to_account_amount: data?.orderData?.pot_add_to_account_amount ?? 0 }
      : {
          pot_add_to_account_amount:0,
        }),

    ...(page === "view"
      ? { pot_open_balance: data?.orderData?.pot_open_balance ?? "" }
      : {
          pot_open_balance: data?.data?.cmrOpenBalance?.cmr_open_balance ?? 0,
        }),

    invoices:
      data?.invoiceData?.map((item) => {
        return {
          id: item?.poit_id,
          poit_invoice_number: item?.poit_invoice_number,
          poit_Doc: "Sales Invoice",
          poit_document_date:
            moment(item?.podt_doc_date).format("YYYY-MM-DD") ??
            moment(today).format("YYYY-MM-DD"),
          poit_delivery_date:
            moment(item?.podt_due_date).format("YYYY-MM-DD") ??
            moment(today).format("YYYY-MM-DD"),
          poit_due_days: item?.podt_due_days ?? 0,
          poit_total_amount: item?.podt_total_amount ?? 0,
          poit_total_payment: item?.podt_current_payment ?? 0,
          poit_due_amount: item?.podt_balance_due ?? 0,
          podt_doc_type: item?.podt_doc_type ?? "",
          poit_status: "",
        };
      }) ?? [],
    paymentModeData: [
      {
        account_id: bankData?.account_id ?? "",
        account_code: bankData?.account_code ?? "",
        account_name: bankData?.account_name ?? "",
        pmt_mode_name: "Bank Transfer",
        bank_reference_number: bankData?.bank_reference_number ?? "",
        date_of_transfer: bankData?.date_of_transfer
          ? moment(bankData?.date_of_transfer).format("YYYY-MM-DD")
          : moment(today).format("YYYY-MM-DD"),
        pmt_total_amount: bankData?.pmt_total_amount ?? (0).toFixed(2),
      },
      {
        account_id: cashData?.account_id ?? "",
        account_code: cashData?.account_code ?? "",
        account_name: cashData?.account_name ?? "",
        pmt_mode_name: "Cash",
        date_of_transfer: cashData?.date_of_transfer
          ? moment(cashData?.date_of_transfer).format("YYYY-MM-DD")
          : moment(today).format("YYYY-MM-DD"),
        pmt_total_amount: cashData?.pmt_total_amount ?? (0).toFixed(2),
      },
      {
        account_id: upiData?.account_id ?? "",
        account_code: upiData?.account_code ?? "",
        account_name: upiData?.account_name ?? "",
        pmt_mode_name: "UPI",
        date_of_transfer: upiData?.date_of_transfer
          ? moment(upiData?.date_of_transfer).format("YYYY-MM-DD")
          : moment(today).format("YYYY-MM-DD"),
        pmt_total_amount: upiData?.pmt_total_amount ?? (0).toFixed(2),
        upi_reference_number: upiData?.upi_reference_number ?? "",
        pmt_id: upiData?.pmt_id ?? "",
      },
      {
        account_id: cardData?.account_id ?? "",
        account_code: cardData?.account_code ?? "",
        account_name: cardData?.account_name ?? "",
        pmt_mode_name: "Card",
        date_of_transfer: cardData?.date_of_transfer
          ? moment(cardData?.date_of_transfer).format("YYYY-MM-DD")
          : moment(today).format("YYYY-MM-DD"),
        pmt_total_amount: cardData?.pmt_total_amount ?? (0).toFixed(2),
        card_number: cardData?.card_number ?? "",
        expiry_date: cardData?.expiry_date
          ? moment(cardData?.expiry_date).format("YYYY-MM-DD")
          : moment(today).format("YYYY-MM-DD"),
      },
      {
        account_id: chequeData?.account_id ?? "",
        account_code: chequeData?.account_code ?? "",
        account_name: chequeData?.account_name ?? "",
        pmt_mode_name: "Cheque",
        date_of_transfer: chequeData?.date_of_transfer
          ? moment(chequeData?.date_of_transfer).format("YYYY-MM-DD")
          : moment(today).format("YYYY-MM-DD"),
        pmt_total_amount: chequeData?.pmt_total_amount ?? (0).toFixed(2),
        cheque_number: chequeData?.cheque_number ?? "",
        date_of_cheque: chequeData?.date_of_cheque
          ? moment(chequeData?.date_of_cheque).format("YYYY-MM-DD")
          : moment(today).format("YYYY-MM-DD"),
      },
    ],
    credit_note_amount: 0,
    journal_entry: 0,
    submittedButton: "",
    fixedCurrentPayment: 0, // its fixed, not going to vary with payment details
    sumOfAmountEnteredInAllInvoices: 0,
    balanceAmt: 0,
    clearDueInput: data?.data?.cmrOpenBalance?.cmr_open_balance ?? 0,
  };
  const [initialValue] = useState(initialFormValues);
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
    paymentModeData: Yup.array().of(
      Yup.object().shape({
        pmt_total_amount: Yup.number(),
        account_id: Yup.string(),
        account_code: Yup.string(),
        account_name: Yup.string(),
        pmt_mode_name: Yup.string(),
        bank_reference_number: Yup.string(),
        date_of_transfer: Yup.date(),
        upi_reference_number: Yup.string(),
        pmt_id: Yup.string(),
        card_number: Yup.string(),
        expiry_date: Yup.date(),
        cheque_number: Yup.string(),
        date_of_cheque: Yup.date(),
      })
    ),
    // .test("paymentModeData-test", null, function (value) {
    //   const errors = [];
    //   value.forEach((paymentMode, index) => {
    //     if (paymentMode.pmt_total_amount > 0) {
    //       if (!paymentMode.account_id) {
    //         errors.push(
    //           this.createError({
    //             path: `paymentModeData[${index}].account_id`,
    //             message: "Account ID is required",
    //           })
    //         );
    //       }
    //       if (!paymentMode.account_code) {
    //         errors.push(
    //           this.createError({
    //             path: `paymentModeData[${index}].account_code`,
    //             message: "Account Code is required",
    //           })
    //         );
    //       }
    //       if (!paymentMode.account_name) {
    //         errors.push(
    //           this.createError({
    //             path: `paymentModeData[${index}].account_name`,
    //             message: "Account Name is required",
    //           })
    //         );
    //       }
    //       if (!paymentMode.pmt_mode_name) {
    //         errors.push(
    //           this.createError({
    //             path: `paymentModeData[${index}].pmt_mode_name`,
    //             message: "Tab is required",
    //           })
    //         );
    //       }
    //       if (
    //         paymentMode.pmt_mode_name === "Bank Transfer" &&
    //         !paymentMode.bank_reference_number
    //       ) {
    //         errors.push(
    //           this.createError({
    //             path: `paymentModeData[${index}].bank_reference_number`,
    //             message: "Bank Reference Number is required",
    //           })
    //         );
    //       }
    //       if (!paymentMode.date_of_transfer) {
    //         errors.push(
    //           this.createError({
    //             path: `paymentModeData[${index}].date_of_transfer`,
    //             message: "Date of Transfer is required",
    //           })
    //         );
    //       }
    //       if (paymentMode.pmt_mode_name === "UPI") {
    //         if (!paymentMode.upi_reference_number) {
    //           errors.push(
    //             this.createError({
    //               path: `paymentModeData[${index}].upi_reference_number`,
    //               message: "UPI Reference Number is required",
    //             })
    //           );
    //         }
    //         if (!paymentMode.pmt_id) {
    //           errors.push(
    //             this.createError({
    //               path: `paymentModeData[${index}].pmt_id`,
    //               message: "Payment ID is required",
    //             })
    //           );
    //         }
    //       }
    //       if (paymentMode.pmt_mode_name === "Card") {
    //         if (!paymentMode.card_number) {
    //           errors.push(
    //             this.createError({
    //               path: `paymentModeData[${index}].card_number`,
    //               message: "Card Number is required",
    //             })
    //           );
    //         }
    //         if (!paymentMode.expiry_date) {
    //           errors.push(
    //             this.createError({
    //               path: `paymentModeData[${index}].expiry_date`,
    //               message: "Expiry Date is required",
    //             })
    //           );
    //         }
    //       }
    //       if (paymentMode.pmt_mode_name === "Cheque") {
    //         if (!paymentMode.cheque_number) {
    //           errors.push(
    //             this.createError({
    //               path: `paymentModeData[${index}].cheque_number`,
    //               message: "Cheque Number is required",
    //             })
    //           );
    //         }
    //         if (!paymentMode.date_of_cheque) {
    //           errors.push(
    //             this.createError({
    //               path: `paymentModeData[${index}].date_of_cheque`,
    //               message: "Date of Cheque is required",
    //             })
    //           );
    //         }
    //       }
    //     }
    //   });
    //   if (errors.length) {
    //     throw new Yup.ValidationError(errors);
    //   }
    //   return true;
    // }),
  });

  const handleSubmitt = (values, actions) => {
    let action_type = paymentOutCreateAction;
    if (page === "Edit") {
      action_type = paymentOutEditAction;
    }

    if (!loading) {
      console.log("----------------------  save    ----------------------");
      if (values?.submittedButton === "draft") {
        if (checkedId.length === 0) {
          errorToast("Please select invoices to save.");
          return;
        }
      }

      setLoading(true);
      dispatch(
        action_type(
          {
            paymentData: {
              is_customer: values.is_customer,
              ...(values?.pot_id ? { pot_id: values?.pot_id } : {}),
              is_draft_order:
                values?.submittedButton === "draft" ? true : false,
              cmr_id: values?.cmr_id,
              cmr_name: values?.cmr_name?.label,
              cmr_code: values?.cmr_code?.label,
              pot_posting_date: values?.pot_posting_date,
              pot_due_date: values?.pot_due_date,
              pot_doc_date: values?.pot_doc_date,

              pot_current_payment:
                values?.pot_cmr_amount_paid <= 0
                  ? 0
                  : values?.pot_cmr_amount_paid,
              //    +
              // (parseFloat(values?.pot_open_balance) > 0
              //   ? parseFloat(values?.pot_open_balance)
              //   : 0)
              // -
              // parseFloat(values?.credit_note_amount)
              pot_total_amount: values.pot_total_amount,
              pot_add_to_account_amount: values?.pot_add_to_account_amount,
              payment_journal_remarks: values?.payment_journal_remarks,
              ...(values?.pot_open_balance
                ? {
                    pot_open_balance: values?.clearDueInput
                      ? values?.clearDueInput
                      : values?.pot_open_balance,
                  }
                : {}), // only for view and edit
            },
            ...(!clearDue && {
              invoicePaymentData: (values?.invoices || [])
                .filter((item) => checkedId?.includes(item.id))
                .map((item) => ({
                  poit_invoice_number: item?.poit_invoice_number,
                  poit_id: item?.id,
                  podt_due_days: item?.podt_due_days,
                  podt_balance_due: item?.poit_due_amount,
                  podt_total_amount: item?.poit_total_amount,
                  podt_current_payment: item?.poit_total_payment,
                  podt_doc_date: item?.poit_document_date,
                  podt_due_date: item?.poit_delivery_date,
                  podt_doc_type: item?.podt_doc_type,
                })),
            }),

            paymentModeData:
              values?.paymentModeData?.filter(
                (item) => item?.pmt_total_amount > 0
              )?.length > 0
                ? values.paymentModeData.filter(
                    (item) => item?.pmt_total_amount > 0
                  )
                : [values.paymentModeData?.[0]],
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const onSuccess = (data) => {
    setLoading(false);

    successToast(data?.data?.message);
    navigate("/purchase-payment-out");
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={handleSubmitt}
    >
      {({ values, errors }) => {
        return (
          <Form className="h-full w-full">
            <div className="flex flex-col h-full ">
              <div class="first-div py-1 flex flex-col gap-2">
                <PaymentInOutHeader
                  page={page}
                  clearDue={clearDue}
                  setClearDue={setClearDue}
                  section="pot"
                  setCheckedId={setCheckedId}
                  searchRef={searchRef}
                  disabled={disabled}
                />
              </div>

              <div
                className="flex flex-col"
                style={{
                  maxHeight: `calc(100% - ${heightOfFirstDiv}px)`,
                  height: `calc(100% - ${heightOfFirstDiv}px)`,
                }}
              >
                <PaymentInOutTable
                  clearDue={clearDue}
                  page={page}
                  section="pot"
                  disabled={disabled}
                  tableHeading={heading}
                  checkedId={checkedId}
                  setCheckedId={setCheckedId}
                  tableBodyData={values?.invoices}
                />
                <LoadingOverlay isLoading={loading} />

                <PaymentInOutFooter
                  clearDue={clearDue}
                  page={page}
                  submitLoading={loading}
                  loading={loading}
                  section="pot"
                  disabled={disabled}
                  setPaymentMeans={setPaymentPanel}
                  checkedId={checkedId}
                  setOpen={setPaymentPanel}
                />
              </div>

              <PurchasePaymentPanel
                clearDue={clearDue}
                section="pot"
                page={page}
                checkedId={checkedId}
                disabled={disabled}
                submitLoading={loading}
                payModesList={payModesList}
                paymentModeData={values.paymentModeData}
                open={paymentPanel}
                setOpen={setPaymentPanel}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEditViewPurchasePaymentOut;
